import Gold from 'assets/images/gold.svg'
import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import Link from 'components/Link'
import Row from 'components/Row'
import Text from 'components/Text'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { getSupportLink } from 'services/urlService'
import styled from 'styled-components'

import Container from '../Modal/Container'

const Description = styled(Row)`
  justify-content: center;
  margin-bottom: 2rem;
  padding: 0 2rem;
`

const GoldImage = styled.img`
  height: 4rem;
  margin-bottom: 1.5rem;
`

const Final = ({ intl }: WrappedComponentProps) => (
  <Container
    sub={intl.formatMessage(messages.sub_title_final_gold)}
    title={
      <Column>
        <GoldImage src={Gold} />
        {intl.formatMessage(messages.title_final_gold)}
      </Column>
    }
    theme='dark'
  >
    <Description>
      <Text color='dark200'>
        {intl.formatMessage(messages.button_need_help)}{' '}
        <Link
          color='blue600'
          href={getSupportLink(intl.locale)}
          rel='noopener noreferrer'
          target='_blank'
        >
          {intl.formatMessage(messages.contact_support)}
        </Link>
      </Text>
    </Description>

    <CeruleanButton e2e='closeButton' type='submit'>
      {intl.formatMessage(messages.button_close)}
    </CeruleanButton>
  </Container>
)

export default injectIntl(Final)
